import * as React from 'react'
import { Col, Row } from 'reactstrap';
import { queryNoTracking } from '../services/DataService';
import { accentUtils, formHelper, t } from '../services/HelperService';
import { accountTypes } from '../services/JobService';
import { getUser } from '../services/UserService';
import { AccentSpinner } from './AccentSpinner';
import { AccentAddress, AccentAddressNoViewState } from './bound/AccentAddress';
import { AccentFormCtrlNoViewState } from './bound/AccentFormCtrl';


const query_Company_SelectList = queryNoTracking("Company_SelectList");
const query_Company = queryNoTracking("Company");

export class NewContactCtrl extends React.Component {

    constructor(props) {
        super(props);


        var me = this;

            
        
        this.contactTitle = "application_strings.wizards.newContactWizard.contactHeader";
        this.companyTitle = "application_strings.wizards.newContactWizard.companyHeader";

        if (!accentUtils.isNull(this.props.contactTitle)) {
            this.contactTitle = this.props.contactTitle;
        }
        if (!accentUtils.isNull(this.props.companyTitle)) {
            this.companyTitle = this.props.companyTitle;
        }


        this.userModel = getUser();
        this.sideBar = this.props.sideBar;

        this.loadedWithCompanyID = !accentUtils.isNull(this.props.company) && !accentUtils.isEmpty(this.props.company.ID);
        var enableCompany = !accentUtils.isNull(this.props.company) && (!accentUtils.isEmpty(this.props.company.ID) || !accentUtils.isEmpty(this.props.company.Name));



        this.state = {
            loading: false,
            company: null,
            enableCompany: enableCompany
        };


        this.contactModel = this.props.contact;
        this.companyModel = this.props.company;

        this.otherModel = {
            AddCompany: enableCompany,
            setProperty: function (name, val) {
                this[name] = val;
            }                            
        };


        this.componentDidMount = this.componentDidMount.bind(this);
        this.componentDidUpdate = this.componentDidUpdate.bind(this);
        this.validateContactPhone = this.validateContactPhone.bind(this);
        this.getCompanyQuery = this.getCompanyQuery.bind(this);
        this.loadCompany = this.loadCompany.bind(this);
        this.fireChange = this.fireChange.bind(this);
    }

    componentDidMount() {
    }

    componentDidUpdate() {

    }


    fireChange() {
        if (!accentUtils.isNull(this.props.onChange)) {
            this.props.onChange();
        }
    }

    loadCompany(companyID) {

        var me = this;

        query_Company.getFirstOrDefault({ id: companyID, include: "Address" }).then(function (company) {
            if (!accentUtils.isNull(company)) {
                if (me.props.onCompanyLoaded) {


                    var args = { company: company };

                    me.props.onCompanyLoaded(args);

                    company = args.company;

                }

                me.companyModel = company;
            }
            me.setState({ loading: false, company: company, enableCompany: !accentUtils.isNull(company) });
        });
    }

    getCompanyQuery() {
        return query_Company_SelectList.getAllAsQueryableWithCache({ includeID: accentUtils.isNull(this.contactModel.CompanyID) ? null : this.contactModel.CompanyID });
    }


    validateContactPhone(value) {

        var isValid = !accentUtils.isEmpty(this.contactModel.WorkPhone) ||
            !accentUtils.isEmpty(this.contactModel.HomePhone) ||
            !accentUtils.isEmpty(this.contactModel.Mobile) ||
            !accentUtils.isEmpty(this.contactModel.Email);


        if (!isValid)
            return { Msg: "At least one contact number/email is required", Type: "Error" };

        return null;
    }

    render() {

        var me = this;

        if (this.state.loading) {
            return (<AccentSpinner />);
        }



        var contactDetailsRequired = { details: true, address: true };




        var firstName = formHelper.getFieldCtrlModel(this.contactModel, "FirstName", "text", true, { tagNamePrefix: "Contact.", readOnly: this.props.disableNames, label: "application_strings.wizards.newContactWizard.firstName" });
        var lastName = formHelper.getFieldCtrlModel(this.contactModel, "LastName", "text", true, { tagNamePrefix: "Contact.", readOnly: this.props.disableNames, label: "application_strings.wizards.newContactWizard.lastName" });
        var workPhone = formHelper.getFieldCtrlModel(this.contactModel, "WorkPhone", "phone", (contactDetailsRequired.details ? this.validateContactPhone : false), { tagNamePrefix: "Contact.", label: "application_strings.wizards.newContactWizard.workPhone" });
        var homePhone = formHelper.getFieldCtrlModel(this.contactModel, "HomePhone", "phone", (contactDetailsRequired.details ? this.validateContactPhone : false), { tagNamePrefix: "Contact.", label: "application_strings.wizards.newContactWizard.homePhone" });
        var mobile = formHelper.getFieldCtrlModel(this.contactModel, "Mobile", "mobile", (contactDetailsRequired.details ? this.validateContactPhone : false), { tagNamePrefix: "Contact.", label: "application_strings.wizards.newContactWizard.mobile" });
        var email = formHelper.getFieldCtrlModel(this.contactModel, "Email", "email", (contactDetailsRequired.details ? this.validateContactPhone : false), { tagNamePrefix: "Contact.", label: "application_strings.wizards.newContactWizard.email" });


        var companyReadOnly = null;
        var addCompany = null;
        var companyName = null;
        var companyEmail = null;
        var companyPhone = null;
        var companyAccountType = null;
        var businessNumber = null;
        var companyMobile = null;
        var companyWWW = null;

        if (!this.props.hideCompany) {

            companyReadOnly = !this.otherModel.AddCompany;

            var companyNameReadonly = companyReadOnly || this.loadedWithCompanyID;

            addCompany = formHelper.getFieldCtrlModel(this.otherModel, "AddCompany", "check", false, { readOnly: this.loadedWithCompanyID, label: "application_strings.wizards.newContactWizard.company" });
            companyName = formHelper.getFieldCtrlModel(this.companyModel, "Name", "textLookup", true, { tagNamePrefix: "Company.", readOnly: companyNameReadonly, label: "application_strings.wizards.newContactWizard.companyName", displayField: "Name", source: this.getCompanyQuery, sourceType: "Company" });

            companyEmail = formHelper.getFieldCtrlModel(this.companyModel, "Email", "text", false, { tagNamePrefix: "Company.", readOnly: companyReadOnly, label: "application_strings.wizards.newContactWizard.companyEmail" });
            companyPhone = formHelper.getFieldCtrlModel(this.companyModel, "Phone", "phone", false, { tagNamePrefix: "Company.", readOnly: companyReadOnly, label: "application_strings.wizards.newContactWizard.companyPhone" });
            companyAccountType = formHelper.getFieldCtrlModel(this.companyModel, "AccountType", "select", true, { label: "application_strings.wizards.newContactWizard.companyAccountType", readOnly: companyReadOnly, source: accountTypes.getPicklistSource() });
            businessNumber = formHelper.getFieldCtrlModel(this.companyModel, "BusinessNumber", "text", false, { tagNamePrefix: "Company.", readOnly: companyReadOnly, label: "application_strings.wizards.newContactWizard.companyBusinessNumber" });
            companyMobile = formHelper.getFieldCtrlModel(this.companyModel, "Mobile", "mobile", false, { tagNamePrefix: "Company.", readOnly: companyReadOnly, label: "application_strings.wizards.newContactWizard.companyMobile" });
            companyWWW = formHelper.getFieldCtrlModel(this.companyModel, "WWW", "text", false, { tagNamePrefix: "Company.", readOnly: companyReadOnly, label: "application_strings.wizards.newContactWizard.companyWWW" });

            companyName.field.options.onChange = function (e) {

                if (accentUtils.isEmpty(e.value)) {
                    if (me.props.onCompanyLoaded) {

                        var c = { company: null };

                        me.props.onCompanyLoaded(c);
                        me.companyModel = c.company;
                    }
                } else if (typeof e.value === "string") {

                } else {


                    if (!accentUtils.isEmpty(e.value.ID) && Number(e.value.ID) > 0) {

                        var companyID = Number(e.value.ID);

                        me.loadCompany(companyID);
                    }

                    
                }

                me.forceUpdate();

            };


            addCompany.field.options.onChange = function () {
                if (me.props.onAddCompanyChange) {
                    me.props.onAddCompanyChange(me.otherModel.AddCompany);
                }

                if (!me.otherModel.AddCompany && me.props.onCompanyLoaded) {
                    var c = { company: null };

                    me.props.onCompanyLoaded(c);
                    me.companyModel = c.company;
                }

                me.setState({ enableCompany: me.otherModel.AddCompany });
            };

        }

        firstName.field.options.onChange = function (e) {
            me.fireChange();
        };
        lastName.field.options.onChange = function (e) {
            me.fireChange();
        };

        workPhone.field.options.onChange = function (e) {
            me.refs.phoneHomeCtrl.refresh();
            me.refs.phoneMobileCtrl.refresh();
            me.refs.emailCtrl.refresh();
            me.fireChange();
        };
        homePhone.field.options.onChange = function (e) {
            me.refs.phoneWorkCtrl.refresh();
            me.refs.phoneMobileCtrl.refresh();
            me.refs.emailCtrl.refresh();
            me.fireChange();
        };
        mobile.field.options.onChange = function (e) {
            me.refs.phoneWorkCtrl.refresh();
            me.refs.phoneHomeCtrl.refresh();
            me.refs.emailCtrl.refresh();
            me.fireChange();
        };
        email.field.options.onChange = function (e) {
            me.refs.phoneWorkCtrl.refresh();
            me.refs.phoneMobileCtrl.refresh();
            me.refs.phoneHomeCtrl.refresh();
            me.fireChange();
        };



        var sideView = null;


        var col = 6;

        if (this.props.hideCompany) {
            col = 12;
        }


        if (!accentUtils.isNull(this.sideBar)) {
            col = 4;
            sideView = <Col md={4}>
                {this.sideBar}
            </Col>;
        }
        
        return (
            <React.Fragment>
                <Row>
                    <Col md={col}>
                        {this.props.hideTitles ? null :
                            <React.Fragment>
                                <h5>{t(this.contactTitle)}</h5>
                                <Row><Col className="accentNewContactWizard-cs" md={12}>&nbsp;</Col></Row>
                            </React.Fragment>
                        }
                        <Row>
                            <Col md={6}>
                                <AccentFormCtrlNoViewState ref="ctrlFirstName" model={firstName} hidePre />
                            </Col>
                            <Col md={6}>
                                <AccentFormCtrlNoViewState ref="phoneMobileCtrl" model={mobile} hidePre />
                            </Col>
                        </Row>
                        <Row>
                            <Col md={6}>
                                <AccentFormCtrlNoViewState model={lastName} hidePre />
                            </Col>
                            <Col md={6}>
                                <AccentFormCtrlNoViewState ref="phoneWorkCtrl" model={workPhone} hidePre />
                            </Col>
                        </Row>
                        <Row>
                            <Col md={6}>
                                <AccentFormCtrlNoViewState ref="emailCtrl" model={email} hidePre />
                            </Col>
                            <Col md={6}>
                                <AccentFormCtrlNoViewState ref="phoneHomeCtrl" model={homePhone} hidePre />
                            </Col>
                        </Row>
                        {this.props.hideContactAddres ? null :
                            <Row>
                                <Col md={12}>
                                    <Row><Col md={12}>&nbsp;</Col></Row>
                                    <Row><Col md={12}><label>{t("application_strings.wizards.newContactWizard.contactSiteAddressHeader")}</label></Col></Row>
                                    <AccentAddressNoViewState entity={this.contactModel} addressMember="Address" required={contactDetailsRequired.address} tagNamePrefix="Contact" />
                                </Col>
                            </Row>
                        }
                    </Col>
                    {this.props.hideCompany ? null :
                        <Col md={col}>
                            <h5>{t(this.companyTitle)}</h5>
                            <AccentFormCtrlNoViewState model={addCompany} hidePre />
                            <Row>
                                <Col md={6}>
                                    <AccentFormCtrlNoViewState model={companyName} hidePre />
                                </Col>
                                <Col md={6}>
                                    <AccentFormCtrlNoViewState model={companyWWW} hidePre />
                                </Col>
                            </Row>
                            <Row>
                                <Col md={6}>
                                    <AccentFormCtrlNoViewState model={companyPhone} hidePre />
                                </Col>
                                <Col md={6}>
                                    <AccentFormCtrlNoViewState model={companyEmail} hidePre />
                                </Col>
                            </Row>
                            <Row>
                                <Col md={6}>
                                    <AccentFormCtrlNoViewState model={companyMobile} hidePre />
                                </Col>
                                <Col md={6}>
                                    <AccentFormCtrlNoViewState model={companyAccountType} hidePre />
                                </Col>
                            </Row>
                            <Row>
                                <Col md={6}>
                                </Col>
                                <Col md={6}>
                                    <AccentFormCtrlNoViewState model={businessNumber} hidePre />
                                </Col>
                            </Row>
                            <Row>
                                <Col md={12}>
                                    <Row><Col md={12}>&nbsp;</Col></Row>
                                    <Row><Col md={12}><label>{t("application_strings.wizards.newContactWizard.companyAddressHeader")}</label></Col></Row>
                                    <AccentAddressNoViewState
                                        key={`CompanyAddress_${this.companyModel?.ID ?? 'none'}_${this.companyModel?.Address?.ID ?? 'none'}`}
                                        entity={this.companyModel}
                                        addressMember="Address"
                                        readOnly={companyReadOnly}
                                        required={true}
                                        tagNamePrefix="Company"
                                    />
                                </Col>
                            </Row>

                        </Col>
                    }
                    {sideView}
                </Row>
            </React.Fragment>
        );
    }
}
